<template>
<div class="routerview">
    <sidebar :fileExport="fileExport">
        Name:
        <input v-model="$store.state.workflow.name" @input="validate($store.state.workflow, 'name', nameMaxLength)" placeholder="Workflow name"/>
        ({{nameLength}}/25 characters)
        <br>
        <span v-if="$store.state.workflow.timestamp">Creation date: {{formatDate($store.state.workflow.timestamp)}}</span>
        <br><br>
        Description:
        <textarea v-model="$store.state.workflow.description" @input="validate($store.state.workflow, 'description', descriptionMaxLength)" placeholder="Workflow description"/>
        ({{descriptionLength}}/200 characters)
        <br><br><br>
        <button :disabled="!workflowSaveable" @click="save" creator>Save</button>
        <br><br>
        <button @click="editWorkflow">Load / Import</button>
        <br><br>
    </sidebar>
    <div class="actions">
        <div>
            <draggable v-model="actions" :clone="clone" :options="{group:{ name:'steps',  pull:'clone', put:false}, sort: false}">
            <!--<div class="action" v-for="action in actions" :transfer-data="action">
                <svgicon :icon="action.method.toLowerCase()"/><br>
                <span class="method">{{action.method}}</span>
            </div>-->
                <div class="step" v-for="(step, index) in actions" :key="step.settings.uid">
                    <div class="action">
                        <svgicon :icon="step.method.toLowerCase()"/><br>
                        <span class="method">{{step.title || step.method}}</span>
                    </div>
                    <!--<keep-alive>-->
                    <component class="properties" :is="step.method" v-model="step.settings" :lastsolvent="null" :solvents="solvents" :uplcfiles="uplcfiles"></component>
                    <!--</keep-alive>-->
                </div>
            </draggable>
        </div>
    </div>
    <!--<div class="separatorline"></div>-->
    <div class="workflowcontainer" :class="{'empty':!$store.state.workflow.steps.length}">
        <draggable class="workflow" v-model="$store.state.workflow.steps" :options="{group:'steps', animation: 150, filter: 'input', preventOnFilter: false}">
            <div class="step" :class="{invalid: !step.valid}" v-for="(step, index) in $store.state.workflow.steps" :key="step.settings.uid">
                <div class="action">
                    <font-awesome-icon :icon="['fas', 'times']" class="remove" @click="deleteStep(index)"/>
                    <svgicon :icon="step.method.toLowerCase()"/><br>
                    <span class="method">{{step.title || step.method}}</span>
                </div>
                <!--<keep-alive>-->
                <component class="properties" :is="step.method" v-model="step.settings" :lastsolvent="null" :solvents="solvents" :uplcfiles="uplcfiles"></component>
                <!--</keep-alive>-->
                <!--<div class="types">{{currentInputTypes[index]}}<br>{{currentOutputTypes[index]}}</div>-->
            </div>
        </draggable>
        <div v-if="$store.state.workflow.steps.length" draggable="false" class="addstep" :class="{firststep: !$store.state.workflow.steps.length}">
            <div class="plus">
                <font-awesome-icon :icon="['fal', 'plus-circle']" size="3x"/>
            </div>
            <div class="text">Drop additional steps here</div>
        </div>
    </div>
</div>

</template>

<script>
import draggable from 'vuedraggable'
import Centrifugation from './actions/Centrifugation'
import Dispensing from './actions/Dispensing'
import Filtration from './actions/Filtration'
import Extraction from './actions/Extraction'
import Pipetting from './actions/Pipetting'
import Sonication from './actions/Sonication'
import Pause from './actions/Pause'
import Washing from './actions/Washing'
import Weighing from './actions/Weighing'
import HPLC from './actions/HPLC'
import '../icons'
import WorkflowOpener from './WorkflowOpener'


export default {
    methods: {
        validate(obj, key, maxlen){
        	if (obj[key]) {
        		obj[key] = obj[key].replace(/[^A-Za-z0-9_ -]/g, '').replace(/ +/g, ' ').substring(0, maxlen);

        	}                
            if(maxlen == this.descriptionMaxLength){
                this.descriptionLength = obj[key].length;
                console.log(obj[key].length);
            }
            else if(maxlen == this.nameMaxLength){
                this.nameLength = obj[key].length;
            }
        },
        isInvalid(step, index){
            /*if(!step.settings.inputTypes){
                return false;
            }
            if(!index){
                return false;
            }
            for(let i = index - 1; i >= 0; i--){
                if(this.$store.state.workflow.steps[i].settings.outputType){
                    if(step.settings.inputTypes.includes(this.$store.state.workflow.steps[i].settings.outputType)){
                        return false;
                    }else{
                        return true;
                    }
                }else{
                    if()
                }
            }*/
            return false;
        },
        editWorkflow(){
            this.$modal.show(WorkflowOpener,{

                },{
                width: 750,
                height: 415
            })
        },
        fileExport(){
            if(!this.workflowValid){
                return;
            }
            this.download(this.$store.state.workflow.name+'.samwf', JSON.stringify(this.$store.state.workflow, null, 4))
        },
        clone(original){
            let n = {
                id: original.id,
                method: original.method,
                title: original.title,
                settings: {
                    uid: Math.floor(Math.random()*1000000),
                },
                valid: true,
            };
            return n;
        },
        padZero(input){
            return ('00'+input).slice(-2);
        },
        formatDate(timestamp){
        let d = new Date(timestamp);
            return `${this.padZero(d.getDate())}.${this.padZero(d.getMonth()+1)}.${this.padZero(d.getYear()-100)} ${this.padZero(d.getHours())}:${this.padZero(d.getMinutes())}:${this.padZero(d.getSeconds())}`
        },
        deleteStep(step){
            console.log(this.$store.state.workflow.steps[step])
            this.$store.state.workflow.steps.splice(step, 1);
        },
        download(filename, text) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        save(){
            let workflow = {
                steps: [],
                typedSteps: [],
                name: this.$store.state.workflow.name.trim(),
                description: this.$store.state.workflow.description.trim(),
                inputTypes: this.workflowInputTypes,
                timestamp: Date.now(),
            };
            for(let i = 0; i < this.$store.state.workflow.steps.length; i++){
                workflow.steps.push({
                    method: this.$store.state.workflow.steps[i].method,
                    settings: JSON.parse(JSON.stringify(this.$store.state.workflow.steps[i].settings))
                })
                workflow.typedSteps.push({
                    method: this.$store.state.workflow.steps[i].method,
                    settings: JSON.parse(JSON.stringify(this.$store.state.workflow.steps[i].settings))
                })
                Object.keys(workflow.steps[i].settings).forEach((key)=>{
                    workflow.steps[i].settings[key] += '';
                })
            }
            this.$api.compatibilityEmit('saveWorkflow', workflow);
            this.$store.state.workflow.timestamp = Date.now();
            this.$set(this.$store.state.workflow, 'originalDescription', this.$store.state.workflow.description);
            this.$set(this.$store.state.workflow, 'originalName', this.$store.state.workflow.name);
            this.$notify({
                type: 'success',
                text: 'Workflow saved',
            });
            this.getWorkflows();
        },
        check(){

            let workflowInputTypes;
            let currentInputTypes = ['ExSample','MiniSample','SnapvialSample'];
            let error = false;
            this.$store.state.workflow.steps.forEach((step, index)=>{
                if(!step.settings.inputTypes){
                    return;
                }
                if(error){
                    this.$set(this.currentInputTypes, index, []);
                    this.$set(this.currentOutputTypes, index, []);
                    step.valid = false;
                }
                currentInputTypes = currentInputTypes.filter(type=>step.settings.inputTypes.includes(type));
                if(!currentInputTypes.length){
                    step.valid = false;
                    error = true;
                }else{
                    step.valid = true;
                }
                this.$set(this.currentInputTypes, index, currentInputTypes.map(t=>t.substring(0,4)));
                if((step.settings.outputType || index+1 === this.$store.state.workflow.steps.length) && !workflowInputTypes){
                    workflowInputTypes = currentInputTypes;
                }
                if(step.settings.outputType){
                    currentInputTypes = [step.settings.outputType];
                }
                this.$set(this.currentOutputTypes, index, currentInputTypes.map(t=>t.substring(0,4)));
            });
            this.$set(this, 'workflowInputTypes', workflowInputTypes);
        },
        getWorkflows(){
            this.$api.compatibilityEmit('listWorkflows', false, null, (workflows)=>{
                this.workflows = workflows;
            });
        }
    },
    components: {
        draggable,
        Centrifugation,
        Dispensing,
        Filtration,
        Extraction,
        Pipetting,
        Sonication,
        Pause,
        Washing,
        Weighing,
        HPLC
    },
    watch: {
        
    },
    mounted(){
        //this.actions.forEach(()=>{
            //this.actions.
        this.timer = setInterval(this.check, 500);
        //})
        this.getWorkflows();
        this.validate('','',null);

    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed: {
        workflowValid(){
            let valid = true;
            this.$store.state.workflow.steps.forEach((step,index)=>{
                if(this.isInvalid(step, index)){
                    valid = false;
                }
            })
            if(!this.$store.state.workflow.name || !this.$store.state.workflow.description){
                return false;
            }
            return valid;
        },
        workflowSaveable(){
        	if (this.$store.state.workflow.name) {
        		const sameWfl = this.workflows.find(w=> w.name === this.$store.state.workflow.name.trim());
	            if (sameWfl){
	                if (sameWfl.versions.filter(v=> v.description === this.$store.state.workflow.description.trim()).length > 0){
	                    return false;
	                }
	            }
       			return this.workflowValid;
        	}
        	return false;    
        },

    },
    props: [
        'workflow',
    ],
    data: function(){
        return {
            workflows: [],
            timer: null,
            currentInputTypes: [],
            currentOutputTypes: [],
            workflowInputTypes: [],
            nameLength: 0,
            nameMaxLength: 25,
            descriptionLength: 0,
            descriptionMaxLength: 200,
            actions: [
                {  
                   id:'B',
                   icon:'weighing',
                   method:'Weighing',
                   settings:{  
                      uid:443254
                   }
                },
                {  
                   id:'M',                   
                   invalidPredecessors:[
                      'HPLC',
                      'Filtration',
                   ],
                   icon:'extraction',
                   method:'Extraction',
                   title:'Shaking',
                   settings:{  
                      uid:345435
                   }
                },
                {  
                   id:'D',                   
                   invalidPredecessors:[
                      'HPLC',
                      'Filtration',
                   ],
                   icon:'dispensing',
                   method:'Dispensing',
                   settings:{  
                      uid:534534
                   }
                },
                {  
                   id:'P',
                   icon:'pipetting',
                   method:'Pipetting',
                   settings:{  
                      uid:4353
                   }
                },
                {  
                   id:'F',
                   icon:'filtration',
                   method:'Filtration',
                   settings:{  
                      uid:45654
                   }
                },
                {  
                   id:'W',
                   icon:'washing',
                   method:'Washing',
                   settings:{  
                      uid:767546
                   }
                },
                {  
                   id:'C',
                   icon:'centrifugation',
                   method:'Centrifugation',
                   settings:{  
                      uid:5667
                   }
                },
                {  
                   id:'T',
                   icon:'pause',
                   method:'Pause',
                   settings:{  
                      uid:3453465
                   }
                },
                {  
                   id:'US',
                   icon:'sonication',
                   method:'Sonication',
                   settings:{  
                      uid:65724
                   }
                },
                {  
                   id:'UP',
                   icon:'hplc',
                   method:'HPLC',
                   settings:{  
                      uid:9887
                   }
                }
            ],
            solvents: [
                {id: 0, name: 'solvent 0'},
                {id: 1, name: 'solvent 1'},
                {id: 2, name: 'solvent 2'}
            ],
            uplcfiles: [
                'test1.uplcfile',
                'test7.uplcfile',
                'another.uplcfile',
                'lorem.uplcfile',
                'ipsum.uplcfile'
            ]
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .action {
        border-radius: 2px;

        background-color: $accromabluehue;
        height: 80px;
        width: 80px;
        text-align: center;
        margin: 3px;
        display: inline-block;
        position: relative;

        .svg-icon {
            height: 45px;
            margin-top: 11px;
        }
        .method {
            font-size: 1rem;
        }

        .remove {
            display: none;
            width: 10px;
            position: absolute;
            top: 5px;
            left: 5px;
        }
    }
    .step:hover{
        .remove {
            display: block;
        }
    }

    .step {
        border-radius: 2px;
        box-shadow: 2px 2px 5px -2px $accromagrey;
        .properties {
            display: inline-block;
            padding: 4px;
            //padding-top: 13px;
            vertical-align: top;
        }
        .types {
            width: 100px;
            display: inline-block;
            vertical-align: top;
        }
        background-color: $accromabluehue;
        &.invalid {
            background-color: $accromaredhue;
            .action {
                background-color: $accromaredhue;
            }
        }
        margin: 7px;
        font-size: 1rem;

        input {
            //user-select: text !important;
        }
    }


    .actions {
        padding-top: 3px;
        grid-area: actions;
        width: 103px;
        overflow-y: scroll;
        overflow-x: hidden;
        .properties {
            display: none;
        }
        .step {
            padding: 0;
            width: 0;
            margin: 0;
        }
        .action {
            box-shadow: 2px 2px 5px -2px $accromagrey;
        }
    }
    .separatorline {
        border-right: 1px solid $accromablue;
        display: inline-block;
    }
    .workflowcontainer {
        grid-area: workflow;
        overflow-y: scroll;
        overflow-x: hidden;

    }
    .workflow {
        padding-bottom: 100px;
    }
    .empty {
        background: url('../assets/StartWorkflow.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    .addstep {
        height: 70px;
        margin: 10px;
        pointer-events: none;
        transform: translate(0px, -98px);
        //border: 2px dashed #666;
        padding: 10px;
        text-align: center;
        &.firststep {
            padding: 200px 10px;
            color: red
        }
        img {
            width: 100%;
        }
        border-bottom: 1px dashed #666;
        .text {
            display: inline-block;
            vertical-align: middle;
            padding: 0;
            margin: 0;
        }
        .plus {
            display: inline-block;
            vertical-align: middle;
            //height: 30px;
            //width: 30px;
        }
    }

    .routerview {
        display: grid;
        grid-template-columns: 100px 1fr;
        grid-template-rows: 1fr;
        grid-template-areas: 
            "actions workflow";
        overflow: hidden;
    }
</style>
